const WEB_DEVICE_ID_KEY = "web_device_id";

export function getOrCreateWebDeviceId(): string {
  const stored = localStorage.getItem(WEB_DEVICE_ID_KEY);
  if (stored) return stored;
  const id = crypto.randomUUID();
  localStorage.setItem(WEB_DEVICE_ID_KEY, id);
  return id;
}

/** Header our own services read the browser's device id from (spec 2026-10-27). */
export const DEVICE_ID_HEADER = "X-Device-Id";

/**
 * `{ "X-Device-Id": <web_device_id> }` for requests to OUR hosts only (same-origin /api, /iam, /msgs).
 * Never add it to S3 presigned uploads or WHIP/WHEP media-server calls: their CORS rules would reject it.
 */
export function deviceIdHeaders(): Record<string, string> {
  return { [DEVICE_ID_HEADER]: getOrCreateWebDeviceId() };
}
